import styled from "styled-components";
import Icon from "../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
export const SearcherMessage = styled.div.withConfig({
    displayName: "styled__SearcherMessage",
    componentId: "sc-3c63d9f0-0"
})`
	${FlexMixin({
    direction: 'column',
    align: 'center'
})}
	color: ${({ theme  })=>theme.colors.white.base};
	padding: 16px;
	text-align: center;

	& > ${Icon} {
		${FontMixin({
    size: 'xl',
    weight: 'regular',
    height: 'xl'
})}
		margin: 12px 0;
	}

	& > p {
		${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'medium'
})}
		margin-bottom: 16px;
	}
`;

//# sourceMappingURL=styled.js.map